module.exports = __webpack_public_path__ + "img/gold@2x.bb8bc9c.webp";